import {
  actionHandlers,
  ctaRenderers,
  customCallback,
} from '../../../../shared/CommonConfigs/ctaConfig';

class CTABuilder {
  constructor() {}

  create({component, action}) {
    this.Renderer = ctaRenderers[component];
    this.clickHandler = (function() {
      //either ref or array of refs

      if (Array.isArray(action)) {
        return action.map(actionToPerform => {
          return actionHandlers[actionToPerform?.type];
        });
      } else {
        return [actionHandlers[action?.type] || customCallback];
      }
    })();
    return this;
  }
}

export default CTABuilder;
